import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface ConfirmPayoutDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mentorName: string;
  amount: string;
  onConfirm: () => void;
  isPending: boolean;
}

const ConfirmPayoutDialog = ({
  open,
  onOpenChange,
  mentorName,
  amount,
  onConfirm,
  isPending,
}: ConfirmPayoutDialogProps) => {
  const handleConfirm = (e: React.MouseEvent) => {
    // Prevent AlertDialogAction from auto-closing the dialog
    e.preventDefault();
    onConfirm();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="p-6">
        <AlertDialogHeader>
          <AlertDialogTitle>Confirm Payout</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                Are you sure you want to pay{" "}
                <strong className="text-foreground">{amount}</strong> to{" "}
                <strong className="text-foreground">{mentorName}</strong>?
              </p>
              <p className="text-sm">This action cannot be undone.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} disabled={isPending}>
            {isPending ? "Processing..." : "Yes, Create Payout"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmPayoutDialog;
